<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
//import shades from '@/neural/shades3'

export default {}
</script>
